module.exports = __webpack_public_path__ + "static/media/020.f47b97e3.jpg";